export const DATE_FORMAT = 'DD.MM.YYYY';

export enum WorkerStatus {
  NOT_INVITED = 'notInvited',
  INVITED = 'invited',
  ACTIVE = 'active',
  DEACTIVATED = 'deactivated',
  CAN_NOT_BE_ACTIVATED = 'canNotBeInvited',
  WRONG_DATA = 'wrongData',
  ALL = '',
}

export enum WorkerAssigmentContractStatus {
  DRAFT = 'draft',
  WAIT_CONTRAGENT_SIGN = 'waitContragentSign',
  SIGNED = 'signed',
  REJECTED = 'rejected',
  CANCELED = 'canceled',
}

export const SIZES: Array<string> = ['10', '20', '50', '100'];

export enum PaymentType {
  PARTIAL_REPAYMENT = 'partialRepayment',
  FULL_REPAYMENT = 'fullRepayment',
  PAYOUT = 'payout',
}

export const SUPPORTED_LANGUAGES = [
  {
    name: 'Ру',
    value: 'ru',
    title: 'Русский',
  },
  {
    name: 'Ўз',
    value: 'uz_cyrl',
    title: 'Ўзбекча',
  },
  {
    name: "O'z",
    value: 'uz_latn',
    title: "O'zbekcha",
  },
] as const;

export const CURRENCY_OPTIONS = [
  {
    label: 'currency_options.UZS',
    value: 'UZS',
  },
  {
    label: 'currency_options.USD',
    value: 'USD',
  },
  {
    label: 'currency_options.EUR',
    value: 'EUR',
  },
] as const;
